module.exports = __webpack_public_path__ + "static/media/04.768dc1b4.jpg";